import _ from 'lodash'

import * as helpers from 'peach/helpers'

import './underscore'
export { React, ReactDom } from './reactVersions'

// @ts-ignore
window.peach.helpers = _.mapValues(helpers)

// export { React, ReactDom }
